import Vue from 'vue'
import ElementUI from 'element-ui'
import '@/assets/style/elementui.scss'
import '@/assets/style/index.scss'
import '@/assets/style/atomic.scss'
Vue.use(ElementUI /* { size: 'big' } */)
Vue.config.productionTip = false
import App from './App.vue'
import router from './router'
new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
